import {setRef} from '@esgi/ui-kit/utils';
import {RefObject, useCallback, useRef} from 'react';
import {ModalManager, ModalManagerCallback} from './modal-manager';

export function useModal(): RefObject<ModalManager> {
	return useRef<ModalManager>();
}

export function useOpenModal(modalManagerRef: RefObject<ModalManager>, openHandling: ModalManagerCallback<void>): (() => void) {
	const callbackRef = useRef<() => void>();
	setRef(openHandling, callbackRef);

	return useCallback(() => modalManagerRef.current?.open(callbackRef.current), [modalManagerRef]);
}

export function useCloseModal(modalManagerRef: RefObject<ModalManager>, closeHandling: ModalManagerCallback<void>): (() => void) {
	const callbackRef = useRef<() => void>();
	setRef(closeHandling, callbackRef);

	return useCallback(() => modalManagerRef.current?.close(callbackRef.current), [modalManagerRef]);
}
